import { render, staticRenderFns } from "./productImageSlider.vue?vue&type=template&id=31909b20&scoped=true"
import script from "./productImageSlider.vue?vue&type=script&lang=js"
export * from "./productImageSlider.vue?vue&type=script&lang=js"
import style0 from "./productImageSlider.vue?vue&type=style&index=0&id=31909b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31909b20",
  null
  
)

export default component.exports